var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-body"},[_c('table',{staticClass:"table"},[_c('tbody',_vm._l((_vm.data),function(item){return _c('SettingTreeTableRow',{key:item.name,attrs:{"item":item},on:{"toggle":_vm.toggleRow,"edit":_vm.editSetting}})}),1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }